import React from "react";
import Event from "../event";
import moment from "moment";
import horseDefaultImage from "../../../images/horseracing-tmp.png";
import {t} from "../../../helpers/translator";
export default function horseRacingEventTemplate () {
    let { event: data, horseData = {}, gameInfo, market } = this.props;
    let isFavouriteType = data.isFavouriteType;

    if (data && horseData && gameInfo) {
        return <ul>
            <li>
                <p>{horseData.runnerNum}</p> {/* todo was coupleNumber, changed to runnerNum */}
                {
                    !!horseData.drawn &&
                        <p>({horseData.drawn})</p>
                }
            </li>
            <li>
                <div className="h-color-v">
                    {!isFavouriteType && <img src={`${horseData.jockeyInfo && horseData.jockeyInfo.coloursFilename}`} onError={(e) => { e.target.src = horseDefaultImage; }} />}
                </div>
            </li>
            <li>
                <p>
                    {isFavouriteType ? data.type : horseData.name}
                    {horseData.raceHistoryStat?.map(({ type }, ind) => (  
                        <>{ `${ind === 0 ? ' ( ' : ''}${type} ${ind !== horseData.raceHistoryStat.length - 1 ? ', ' : ')'}` }</>
                    ))
                    }
                </p>
                {
                    !isFavouriteType && <p>
                        <small>{t('Age')}: {!isFavouriteType && horseData.age}</small>
                        <small>  &nbsp;{t('Weight')}: {!isFavouriteType && (`${horseData.weightPounds}-${horseData.weightStones}`)}</small>
                        <small>  &nbsp;{t('Form')}: {horseData.formFigures || t("no form")}</small>
                    </p>
                }
            </li>
            <li>
                <p>{(!isFavouriteType && horseData.trainerInfo) && `${horseData.trainerInfo.name} / ${horseData.jockeyInfo.name} (${horseData.jockeyInfo.allowancePounds})`}</p>
            </li>
            {
                market === 'winner' &&
                <>
                    <li className="horse-c-w price">
                        {data.nonrunner === 1 ? t("Non Runner") : data.price ? <Event sportType='HORSE' hoursType='PRICE' event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='SP' name="SP" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                </>
            }

            {
                (market === 'forecast' && !isFavouriteType) &&
                <>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? t("Non Runner") : data.sp_enabled ? <Event sportType='HORSE' hoursType='forecast$1' name="1st" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='forecast$2' name="2nd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='forecast$1_2' name="1st or 2nd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                </>
            }

            {
                (market === 'tricast' && !isFavouriteType) &&
                <>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? t("Non Runner") : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$1' name="1st" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$2' name="2nd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$3' name="3rd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$1_2_3' name="1st or 2nd or 3rd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                </>
            }

        </ul>;
    }
    return <div>No Date</div>;
}